import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Statistics from '@/components/statistic/Statistics'

export const statistics = [
	{
		path: '/statistics/',
		name: 'statistics',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/statistics',
					text: 'Statistiche'
				}
			]
		},
		children: [
			{
				path: '/statistics/',
				beforeEnter: ifAuthenticatedOnline,
				component: Statistics
			}
		]
	}
]
